module.exports = __webpack_public_path__ + "8db7778f968b8f8a94e0696085d46207.pdf";